import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectAuth, selectUserRoles } from "../../SharedModule/redux/reducers/auth.reducer";
import {
  fetchMetaProducts,
  SelectProductsMetaLoaded,
  setMetaProducts,
} from "../redux/reducers/metaProducts.reducer";
import {
  startLoadingExternalProducts,
  setIsLoadingExternalProducts,
} from "../redux/reducers/products.reducer";

/**
 * Idempotent hook — loads Products metadata (external clients and projects)
 * exactly once per session, triggered when the Add/Edit Product modal opens.
 *
 * Drives the isLoadingExternalProducts flag so ModalLayout Selects show
 * correct loading state while the fetch is in flight.
 */
export const useProductsMetadata = () => {
  const dispatch = useDispatch();
  const { isAuthenticated } = useSelector(selectAuth);
  const { rolesLoaded } = useSelector(selectUserRoles);
  const metaLoaded = useSelector(SelectProductsMetaLoaded);

  useEffect(() => {
    if (!isAuthenticated || !rolesLoaded || metaLoaded) return;

    (async () => {
      dispatch(startLoadingExternalProducts());
      const metaProducts = await fetchMetaProducts();
      dispatch(setMetaProducts(metaProducts));
      dispatch(setIsLoadingExternalProducts(false));
    })();
  }, [isAuthenticated, rolesLoaded, metaLoaded]); // eslint-disable-line react-hooks/exhaustive-deps
};
